import react from "react";

const SkeletonWrapper = (props) => {
  const { loading = false, skeleton, children } = props;

  if (loading) {
    return skeleton;
  }

  return children;
};

export default SkeletonWrapper;
